import React, { useState } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { Header } from "../components/header";
import { Home } from "../components/Home/home";
import { About } from "../components/About/about";
import { HabilitiesAndCompetences } from "../components/Habilities/habilities-compentences";
import { MicroData } from "../components/MicroData/micro-data";
import { Taxonomia } from "../components/Taxonomia/taxonomia";
import { InterestsPerState } from "../components/InterestsPerState/interests";
import { StatisticsDashboard } from "../components/Datas/data";
import { Form } from "../components/Form/form";
import { Footer } from "../components/Footer/footer";
import { Indication } from "../components/Indications/indication";
import { Pizzas } from "../components/Pizza/pizzas";
import { MarcosBiografy } from "../components/Biografy/marcos";
import { SoniaBiografy } from "../components/Biografy/sonia";
import { ModeloQuestaoEnem } from "../components/ModelQuestionEnem";
import { CourseVideo } from "../components/CourseVideo";

export const Landing: React.FC = () => {
  const [loading, setLoading] = useState(false);

  return (
    <div>
      <Header />
      <Home />
      <About />
      <HabilitiesAndCompetences />
      <ModeloQuestaoEnem />
      <MicroData />
      <ToastContainer />
      <Taxonomia />
      <CourseVideo />
      <InterestsPerState />
      <StatisticsDashboard />
      <Pizzas />
      <MarcosBiografy />
      <SoniaBiografy />
      <Indication />
      <Form />
      <Footer />
    </div>
  );
};
